import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-svgo_points-9",
  "use": "icon-svgo_points-9-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"icon-svgo_points-9\"><path d=\"M0 2a2 2 0 113.999-.001A2 2 0 010 2zm14 0a2 2 0 113.999-.001A2 2 0 0114 2zM7 2a2 2 0 113.999-.001A2 2 0 017 2zm-.01 6.99a2 2 0 113.998-.002 2 2 0 01-3.998.002zM14 16a2 2 0 113.999-.001A2 2 0 0114 16zM0 16a2 2 0 113.999-.001A2 2 0 010 16zm6.99 0a2 2 0 113.998-.001A2 2 0 016.99 16zM0 8.99a2 2 0 113.999-.002A2 2 0 010 8.99zm14 0a2 2 0 113.999-.002A2 2 0 0114 8.99z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol